import React from 'react';
import { Eyebrow, MutedText, PageHeader, PageTitle } from '../ui';
import { getBrotherData } from '../../utils/auth';

export default function DashboardView({ title, children }) {
  const brother = getBrotherData();
  return (
    <>
      <PageHeader>
        <Eyebrow>{brother.position} workspace</Eyebrow>
        <PageTitle>{title}</PageTitle>
        <MutedText>Welcome back, {brother.name}.</MutedText>
      </PageHeader>
      {children}
    </>
  );
}
